<template>
  <gl-page icon-name="gr-list" title="Transaction details">
    <div v-if="load === 'success'" class="contentTransaction">
      <transaction-details :tx="tx" class="contentTransaction__blocks" />
      <transaction-summary :tx="tx" class="contentTransaction__summary" />
      <transaction-i-o :tx="tx" class="contentTransaction__io" />
    </div>
    <div v-else-if="load === 'error'" class="text-gray">
      Unexpected Error!
    </div>
    <gl-loader v-else />
  </gl-page>
</template>

<script>
import GlPage from '@gl/GlPage'
import GlLoader from '@gl/GlLoader'
import TransactionDetails from '@/components/Transaction/TransactionDetails'
import TransactionSummary from '@/components/Transaction/TransactionSummary'
import TransactionIO from '@/components/Transaction/TransactionIO'
import { getTx } from '@/services/api'
import { updatePeriod } from '@/config'

export default {
  name: 'Transaction',
  components: { TransactionIO, TransactionSummary, TransactionDetails, GlPage, GlLoader },
  data() {
    return {
      load: 'loading',
      timer: null,
      tx: {},
    }
  },
  watch: {
    $route() {
      if (this.$route.name === 'Transaction') {
        this.load = 'loading'
        this.loadTransaction()
      }
    },
  },
  async mounted() {
    await this.loadTransaction()
    if (+new Date() - this.tx.time < 60 * 60 * 1000) {
      this.timer = setInterval(() => {
        this.reloadTransaction()
      }, updatePeriod)
    }
  },
  beforeUnmount() {
    clearInterval(this.timer)
  },
  methods: {
    async loadTransaction() {
      const id = this.$route?.params?.id
      if (!id) {
        this.load = 'error'
        return
      }

      const { data } = await getTx(id)
      if (data.state === 'success') {
        this.tx = data.data
        this.load = 'success'
      } else {
        this.load = 'error'
      }
    },
    async reloadTransaction() {
      const id = this.$route?.params?.id
      if (!id || this.load !== 'success') return

      const { data } = await getTx(id)
      if (data.state === 'success') {
        if (this.load === 'success' && this.tx.txid === data.data.txid) this.tx = data.data
        this.load = 'success'
      } else {
        this.load = 'error'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contentTransaction {
  @include grid;

  &__blocks {
    @media (min-width: $breakpoint-md) {
      grid-column: 1 / -1;
    }
  }

  &__summary {
    @media (min-width: $breakpoint-md) {
      grid-column: 1 / 7;
    }
  }

  &__io {
    @media (min-width: $breakpoint-md) {
      grid-column: 7 / 13;
    }
  }
}
</style>
